import React, { forwardRef, useImperativeHandle } from "react";
import  { ReactNotifications , Store } from "react-notifications-component";

const Notifications = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    addNotifications(title, message, type) {
      Store.addNotification({
        title: title,
        message: message,
        type: type,
        insert: "top",
        container: "top-center",
        animationIn: ["animated", "bounceIn"],
        animationOut: ["animated", "fadeOut"],
        width: 330,
        dismiss: {
          duration: 7000,
          showIcon: true,
        },
      });
    },
  }));

  return <ReactNotifications />;
});

export default Notifications;

